import { FormBase } from 'core/components';

export default class UserEmailSignatureEditModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'emailSignature',
                    label: 'USER.EDIT_EMAIL_SIGNATURE.EMAIL_SIGNATURE_LABEL',
                    placeholder: 'USER.EDIT_EMAIL_SIGNATURE.EMAIL_SIGNATURE_PLACEHOLDER',
                    rules: 'string'
                }
            ],
        };
    }
}
